import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fc3c03b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "stopdataflow"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "m 11,20.553914 c 5.276436,0 9.553914,-4.277478 9.553914,-9.553914 0,-5.2764865 -4.277478,-9.553914 -9.553914,-9.553914 -5.2764865,0 -9.553914,4.2774275 -9.553914,9.553914 0,5.276436 4.2774275,9.553914 9.553914,9.553914 z M 15.458494,9.089217 H 6.5415069 v 3.821566 h 8.9169871 z",
            fill: "#6F6F6F",
            class: _normalizeClass([[_ctx.hoverStatus], "highlighted"]),
            "stroke-width": "0"
        }, null, 2)
    ]));
}
